module.exports = __webpack_public_path__ + "img/listClose.d170aa29.png";